import { render, staticRenderFns } from "./IntegrationView.vue?vue&type=template&id=125a4459&scoped=true"
import script from "./IntegrationView.vue?vue&type=script&lang=ts"
export * from "./IntegrationView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125a4459",
  null
  
)

export default component.exports